var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.75C13.09 0.75 0.25 3.57 0.25 9.75V50.25C0.25 56.43 13.09 59.25 25 59.25C36.91 59.25 49.75 56.43 49.75 50.25V9.75C49.75 3.57 36.91 0.75 25 0.75ZM25 5.25C38.05 5.25 44.8 8.49 45.25 9.75C44.8 11.01 38.05 14.25 25 14.25C11.95 14.25 5.11 10.98 4.75 9.78C5.11 8.52 11.86 5.25 25 5.25ZM4.75 15.21C9.55 17.61 17.44 18.75 25 18.75C32.56 18.75 40.45 17.61 45.25 15.21V23.22C44.89 24.48 38.14 27.75 25 27.75C11.86 27.75 5.08 24.45 4.75 23.25V15.21ZM4.75 28.71C9.55 31.11 17.44 32.25 25 32.25C32.56 32.25 40.45 31.11 45.25 28.71V36.72C44.89 37.98 38.14 41.25 25 41.25C11.86 41.25 5.08 37.98 4.75 36.75V28.71ZM25 54.75C11.83 54.75 5.08 51.48 4.75 50.25V42.21C9.55 44.61 17.44 45.75 25 45.75C32.56 45.75 40.45 44.61 45.25 42.21V50.22C44.89 51.48 38.14 54.75 25 54.75Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackUp);
export default __webpack_public_path__ + "static/media/ic-back-up.280e5b7abdb0870baa1e562fee052824.svg";
export { ForwardRef as ReactComponent };